import React from 'react';
import { Card, Col, Flex, Row } from 'antd';
import { CustomParagraph, CustomTitle } from '@/components';
import type { InventoryDeviceSummary } from '../type';

type InventorySummaryCardsProps = {
  summary: InventoryDeviceSummary;
};

const InventorySummaryCards: React.FC<InventorySummaryCardsProps> = ({
  summary,
}) => {
  const cards = [
    {
      id: 'total_devices',
      title: 'Total devices',
      count: summary.total_devices,
    },
    {
      id: 'unused',
      title: 'Unused',
      count: summary.unused,
    },
    {
      id: 'activated',
      title: 'Activated',
      count: summary.activated,
    },
    {
      id: 'returned',
      title: 'Returned',
      count: summary.returned,
    },
  ];

  return (
    <Row
      gutter={[12, 12]}
      className='inventory-summary-row'
      style={{ margin: '8px 0' }}
    >
      {cards.map((card) => (
        <Col
          key={card.id}
          xxl={6}
          xl={6}
          lg={6}
          md={12}
          sm={12}
          xs={12}
          style={{ transition: 'all 0.3s ease' }}
        >
          <Card className='inventory-summary-card'>
            <Flex justify='space-between' align='center'>
              <div>
                <CustomTitle
                  text={card.count ?? 0}
                  color='var(--text-primary)'
                  fontSize='16px'
                  lineHeight='24px'
                  fontWeight='600'
                  marginBottom={0}
                />
                <CustomParagraph
                  text={card.title}
                  color='var(--text-light)'
                  fontSize='14px'
                  fontWeight='400'
                  lineHeight='20px'
                  marginBottom={0}
                  className='toolbar-filterd-text'
                />
              </div>
            </Flex>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default InventorySummaryCards;
